var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2925_34908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.64434 15.3919L4.75782 18.7014L1.51761 18.77C0.549263 16.9739 0 14.919 0 12.7353C0 10.6236 0.513547 8.6323 1.42384 6.87891H1.42454L4.30924 7.40777L5.57291 10.2752C5.30843 11.0462 5.16427 11.874 5.16427 12.7353C5.16437 13.67 5.3337 14.5656 5.64434 15.3919Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2459 10.3555C25.3922 11.1258 25.4684 11.9213 25.4684 12.7344C25.4684 13.6461 25.3726 14.5354 25.19 15.3932C24.5701 18.3123 22.9503 20.8612 20.7064 22.665L20.7057 22.6643L17.0723 22.4789L16.5581 19.2687C18.047 18.3955 19.2106 17.029 19.8235 15.3932H13.0142V10.3555H19.9228H25.2459Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7058 22.6638L20.7065 22.6645C18.5242 24.4186 15.752 25.4681 12.7343 25.4681C7.88481 25.4681 3.66854 22.7576 1.5177 18.7687L5.64443 15.3906C6.71982 18.2607 9.48847 20.3038 12.7343 20.3038C14.1294 20.3038 15.4365 19.9266 16.558 19.2682L20.7058 22.6638Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8624 2.93165L16.7371 6.30901C15.5763 5.58346 14.2042 5.16432 12.7342 5.16432C9.4149 5.16432 6.59447 7.30113 5.57294 10.2741L1.42452 6.87787H1.42383C3.54318 2.79173 7.81262 0 12.7342 0C15.824 0 18.657 1.10061 20.8624 2.93165Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2925_34908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.4684,
    height: 25.4684,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.de02b485d7f787167274596c4f2d4280.svg";
export { ForwardRef as ReactComponent };